/**
 * 会员营销 - 会员分群-人群标签
 */

import {get, post, postJson, deleteApi} from '../axios'

const RESOURCE_BASE_PATH = '/memberLabel/'

// 获取人群标签
export const getLabel = p => get(`${RESOURCE_BASE_PATH}`, p);

// 计算人群数量
export const compute = p => postJson(`${RESOURCE_BASE_PATH}compute`, p);

